import type { Translation } from "../i18n-types"

const fr: Translation = {
  generic: {
    addToCartText: "Ajouter au panier",
    addedToBag: "Ajouté au panier",
    addingToCartText: "Ajout au panier ...",
    reserveInStoreText: "Réserver dans un magasin",
    reserveInStoresubHeadingText:
      "Nous allons vous contacter afin de vous aider avec vos achats.",
    closeText: "Fermer",
    emailCustomerCareLabel: "Couriel du service à la clientèle",
    customerCareHelpText:
      "Veuiller appeller 1-888-DYURMAN (1-888-398-7626) ou compléter le formulaire pour vous aider dans vos achats ou suggestions de cadeaux.",
    customerCareSuccessText:
      "Nous avons reçu votre message. Un représentant vous contactera sous peu.",
    customerServiceLabel: "Service à la clientèle",
    customerServiceText:
      "Pour toutes questions ou demande d'aide, veuiller nous contacter avec fore numéro d'identifiation pour obtenir un service plus rapide.",
    customerServiceNoLabel: "1-888-DYURMAN (398-7626)",
    customerServiceNo: "1-888-398-7626",
    emailUsText: "Envoyer nous un courriel",
    emailCustomerCareText: "Contacter le service à la clientèle",
    emailClientLinkText: "customercare@davidyurman.com",
    termsAndConditionsText: "Conditions générales",
    contactUsText: "Contacters nous",
    contactCustomerCareText: "Contacter le service à la clientèle",
    backToShippingBag: "Retour vers le panier",
    customerCareText: "Service à la clientèle",
    customerCareNumber: "1-888-DYURMAN",
    registerLoginText: "S'inscrire",
    loginText: "S'identifier",
    accountText: "Compte",
    hiText: "Salut",
    cancelBtnText: "Annuler",
    undoBtnText: "défaire",
    confirmBtnText: "Confirmer",
    backgroundImage:
      "https://img.davidyurman.com/is/image/DavidYurman/AccountPlaceholderHero?$hero$",
    removeText: "Enlever",
    systemErr:
      "Une erreur est malheureusement survenue. Veuiller contacter le service à la clientèle pour régler ce problème au 1-888-DYURMAN (888-398-7626).",
    appHeaderName: "David Yurman",
    availabilitytext: "Disponibilité",
    inStocktext: "Disponible",
    outOfStockText: "En rupture de stock",
    priceDisclaimer: "Les prix inclus les taxes et les frais de livraison.",
    errorOccurredText: "Une erreur est survenue",
    editText: "Modifier",
    epsSizeNotAvailableText: "Non disponible",
    styleNumberLabel: "Numéro de style",
    colorLabel: "Couleur",
    removingText: "Enlevé...",
    charLeftText: "Caractères restant",
    saveText: "Sauvergarder",
    cancelText: "Annuler",
    nameText: "Nom",
    selectDropDownLabel: "Selectionner",
    productDetailsLabel: "Détails du produit",
    printLabel: "Imprimer",
    loadingText: "Chargement",
    backToTopLabel: "Retour au début",
    allInformationRequired: "Toutes l'information est requise",
    toHomepage: "Retour vers la page d'entrée",
  },
  bracelets: {
    addMore: "Add More",
    copyClipboard: "Copied to clipboard",
    copyCTA: "Copy This Link",
    copyDescription:
      "Copy the link below to share your curated assortment with friends and family.",
    done: "Done",
    introHeadline: "Select Your Bracelets",
    introDescription:
      "Choose your favorite styles, metals and gemstones for layering. Once you’ve made your selection, tap or click a design to move it higher or lower in your stack. If you’d like to remove a bracelet, tap or click the X next to it.",
    help: "Besoin d'aide?",
    limitHeadline: "Limite atteinte",
    limitDescription:
      "Vous ne pouvez plus ajouter de bracelet. Enlevez-en un pour pouvoir en ajouter un autre.",
    modify: "Modifier",
    moreInfo: "Pour plus d'information",
    nextStep: "Étape suivante",
    quickView: "Vue en détail",
    rearrange: "Modifier l'ordre",
    previewSelection: "Preview Your Selection",
    reviewSelection: "Review Your Selection",
    reviewStack: "Review Your Stack",
    selected: "Selected",
    share: "Share This",
    viewDetails: "View Details",
  },
  amulets: {
    amuletGridHeadline: "Pendantifs choisi ({0} de {1}) ",
    changeChain: "Changez la chaîne",
    chooseHeadline: "Choisissez votre chaîne",
    chooseChain: "Choisissez une chaine",
    copyClipboard: "Copied to clipboard",
    copyCTA: "Copy This Link",
    copyDescription:
      "Copy the link below to share your curated assortment with friends and family.",
    done: "Done",
    expand: "Expand",
    introHeadline: "Add Amulets",
    introDescription:
      "Drag and drop your favorite designs to see them on your chain.",
    help: "Need Help?",
    limit: "Limit Reached",
    limitDescription:
      "You cannot add any more amulets. Please remove an amulet to add this design.",
    moreInfo: "Click for More Info",
    nextStep: "Next Step",
    modify: "Modify",
    previewNecklace: "Preview Necklace",
    rearrange: "Rearrange",
    reviewSelection: "Review Your Selection",
    selected: "Selected",
    share: "Share This",
  },
  search: {
    noResultFoundHeadingText: "Aucun résultat",
    noResultFoundSubHeadingText:
      "Veuiller utiliser un autre critère de recherche.",
    applyFiltersText: "Appliquer",
    clearFiltersText: "Réinitialisation des filtres ",
    sortText: "Trier par",
    filterText: "Filtrer",
    seeAllCollectionsText: "Voir toutes les collections",
    searchSuggestionsText: "Suggestions de recherches",
    productSuggestionsText: "Suggestions de produit",
  },
  productConfig: {
    metalLabel: "Métal",
    motifLabel: "FR Design Motif",
    monogramLabel: "Fr Monogram",
    sizeLabel: "FR SIZE",
    designLabel: "FR Design",
    initialsLabel: "FR Initials",
    engraveThisRingText: "FR Engrave This Ring",
    engraveYourRingText: "FR Engrave Your Ring",
    engraveThisNecklaceText: "FR Engrave This Necklace",
    engraveYourNecklaceText: "FR Engrave Your Necklace",
    selectMetalText: "FR Select a Metal",
    selectDesignText: "FR Select a Monogram",
    selectDesign2Text: "FR or a Design Motif",
    selectDesignDropdownText: "FR Select Design",
    selectMotifText: "FR Select a Design Motif",
    selectMonogramText: "FR Select a Monogram",
    backText: "FR Back",
    nextText: "FR Next",
    enterInitialsText: "FR STEP 2: ENTER INITIALS",
    enter3InitialsText: "FR Enter up to 3 initials",
    fontLabel: "FR STEP 1: CHOOSE A STYLE",
    reviewHeaderText: "FR Review Your Selections",
    reviewPt1HeaderText: "FR Review",
    reviewPt2HeaderText: "FR Your Selections",
    step3MonogramText:
      "FR Traditionally, a monogram features the initial for the last name in the middle, but you can make your mark any way you like.",
    pinkyPDPText:
      "FR Personalize your design with a custom-engraved monogram or motif.",
  },
  form: {
    submitText: "SUBMIT",
    requiredErrorText: "This field is required",
    emptySearchText: "Please enter search term",
    maxLengthError: "Le nombre maximum de caractères est de {0}",
    minLengthError: "Le nombre minimal de caractères est de {0}",
    emailAddressRequiredText: "Please enter an email address",
    invalidEmailErrText: "Invalid email address",
    firstNameRequiredErrText: "Please enter a first name",
    lastNameRequiredErrText: "Please enter a last name",
    invalidNameErrText: "Please enter a valid name",
    streetAddressLabel: "Street Address",
    streetAddressRequiredErr: "Please enter Street Address",
    apartmentAddressLabel: "Apartment/Suite #",
    apartmentAddressRequiredErrText: "Please enter Apartment/Suite #",
    cityLabel: "City",
    cityRequiredErrText: "Please enter City",
    zipCodeLabel: "Zip Code",
    zipCodeRequiredErrText: "Please enter Zip Code",
    zipCodeValidErrText: "Please enter Valid Zip Code",
    postalCodeText: "Postal Code",
    postalCodeRequiredErrText: "Please enter Postal Code",
    postalCodeValidErrText: "Please enter Valid Postal Code",
    stateLabel: "State",
    stateRequiredErrText: "Please select State",
    provinceLabel: "Province",
    provinceRequiredErrText: "Please select Province",
    countryLabel: "Country",
    countryRequiredErrText: "Please select Country",
    inquiryRequiredText: "Please select Inquiry Type",
    phoneNumberLabel: "Phone #",
    phoneNumberRequiredErrText: "Please enter a Phone Number",
    firstNameLabel: "First Name",
    lastNameLabel: "Last Name",
    emailLabel: "Email Address",
    retypeEmailLabel: "Retype Email Address*",
    passwordLabel: "Password*",
    retypePasswordLabel: "Retype Password*",
    passwordRequiredText: "Please enter a password",
    invalidPasswordErrText:
      "Please create a password that meets password requirements detailed below and try again.",
    forgotPasswordText: "Forgot Your Password?",
    loginButtonText: "Log In",
    applybtnText: "Apply",
    genderLabel: "Gender",
    dateOfBirthLabel: "Birthday(MM/DD/YYYY)",
    anniversaryLabel: "Anniversary/Wedding Date (MM/DD/YYYY)",
    resetPasswordText: "Reset Password",
    currentEmailLabel: "Current Email*",
    newEmailLabel: "New Email*",
    confirmEmailLabel: "Confirm Email*",
    updateBtnText: "UPDATE",
    UnsubscribeBtnText: "Unsubscribe",
    anniversaryErrText:
      "Anniversary cannot be lesser than or equal to date of birth",
    invalidAnniversaryErrText: "Please enter a valid anniversary date",
    emailAddressLabel: "Email Address",
    orderNumberText: "Please enter an order number",
  },
  pdp: {
    sizeSelectionErrorText: "Please Select Size",
    braceletSize: "MEN'S Bracelet Size Chart",
    seeSizeChartLabel: "See Size Chart",
    initialLabel: "Initial",
    amountLabel: "Amount",
    rollOverToZoomText: "Roll over to zoom",
    sizeChartText: "Size Chart",
    viewDetailsText: "View Details",
    checkGiftCardBalanceText: "Check David Yurman Gift Card Balance",
    buyEGiftCardText: "Buy An e-Gift Card",
    shareText: "Share",
    gemStoneLabel: "GEMSTONE",
    sharetoFacebook: "share product to facebook",
    sharetoTwitter: "share product to twitter",
    sharetoPinterest: "share product to pinterest",
    pricedFrom6550: "Priced From $6,550*",
    fitAndCareText: "Care",
    pdpImageText: "Product Image",
    contactProductSpecialistText: "CONTACT A PRODUCT SPECIALIST",
    productSpecialistHeading: "Product Specialist",
    weddingBridalText: "Wedding/Bridal",
    notSellOptOutText: "Do Not Sell Opt-Out",
    careText: "",
    gcBrailleCheckboxText: "Click here to receive a braille gift card.",
    notifyDescText:
      "This item is currently not available. Please enter your email address to be notified when this product is available.",
    notifyMeText: "Notify me",
    weWillBeInTouchText: "We will be in touch",
    notifyHeaderCopy: "Notify Me When Available",
    notifyBodyCopy:
      "Please enter your name, phone number, and email address, and we'll connect with you when this design is back in stock",
    notifyConfirmationHeaderCopy: "You're On The List",
    notifyConfirmationBodyCopy:
      "Thank you for your interest in this desgin. We'll reach out to you when it becomes available",
    notifyConfirmationBodyCopyShort:
      " We'll reach out to you when this design becomes available",
    preOrderLabel: "PREORDER",
    preOrderCopyOrderConfirmation:
      "Estimated ship date: $PREORDERDATE. Payment is authorized when your order is confirmed and charged at the time of shipment.",
    preOrderCopy:
      "This design is available for pre-order. Estimated ship date: $PREORDERDATE. Payment is authorized when your order is confirmed and charged at the time of shipment.",
  },
  stackItWith: {
    title: "Stack Title",
    description: "Stack Description",
    customize: "CUSTOMIZE",
    stackCTA: "SHOP THE STACK",
    engagementStackCTA: "ADD BAND TO BAG",
    engagementPerfectBandsTitle: "Perfect Bands",
    engagementPerfectBandsDescription: "Perfect Bands Description",
  },
}

export default fr
